document.addEventListener("DOMContentLoaded", function() {
    var phoneNumber = document.getElementById("phoneNumber");
    var phoneIcon = document.querySelector(".phone-icon");

    window.togglePhoneNumber = function() {
        if (phoneNumber.classList.contains("show")) {
            phoneNumber.classList.remove("show");
            setTimeout(function() {
                phoneNumber.style.display = "none";
            }, 200);
        } else {
            phoneNumber.style.display = "flex";
            setTimeout(function() {
                phoneNumber.classList.add("show");
            }, 10); 
        }
    };

    // Nasłuchiwanie na kliknięcie poza obszarem ikony telefonu
    document.addEventListener("click", function(event) {
        if (!phoneIcon.contains(event.target) && !phoneNumber.contains(event.target)) {
            if (phoneNumber.classList.contains("show")) {
                phoneNumber.classList.remove("show");
                setTimeout(function() {
                    phoneNumber.style.display = "none";
                }, 200);
            }
        }
    });
});